import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@bcf-v2-platforms/platform-apis/window-provider';
import { WorkerReady } from '@bcf-v2-platforms/platform-worker/browser';
import { AppLoaded } from '@bcf-vanilla-ui-ts-v1/shared/app-interaction/app-loaded';

@Injectable({ providedIn: 'root' })
export class AppLoadedService extends AppLoaded {
  constructor(workerReady: WorkerReady, @Inject(WINDOW) window: Window) {
    super(workerReady, window);
  }
}
